// extracted by mini-css-extract-plugin
export default {"full":"Task_full__nXd5k","close":"Task_close__iAsxu"};